import { createFileRoute } from '@tanstack/react-router';

import { LiquidacionesPage } from '@/features/liquidaciones/components/liquidaciones-page';

export const Route = createFileRoute('/_app/remuneraciones/')({
  component: LiquidacionesPage,
});
